export default __webpack_public_path__ + "static/media/O-117.526b7c4b.png";